import { render, staticRenderFns } from "./Landline.vue?vue&type=template&id=797da89e&scoped=true&"
import script from "./Landline.vue?vue&type=script&lang=js&"
export * from "./Landline.vue?vue&type=script&lang=js&"
import style0 from "./Landline.vue?vue&type=style&index=0&id=797da89e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797da89e",
  null
  
)

export default component.exports